module.exports = __webpack_public_path__ + "img/yellow-lily.4f39294b.jpg";